import { useState } from "react";
import {
  AdminDashboardView,
  type DashRow,
  type DashTab,
} from "@/components/admin/dashboard/AdminDashboardView";

/**
 * Public, auth-free preview of the restyled admin dashboard at /preview/dashboard.
 * Uses static mock data so the new design can be reviewed in the browser without
 * signing in. Safe to delete once the design is signed off.
 */
const CLIENT_NAMES = [
  "Atlas Logistics", "Granite Freight", "Harbor Steel Co", "Summit Haulage", "Ironside Mfg",
  "Cedar Transport", "Vanguard Movers", "Bedrock Materials", "Pioneer Distribution", "Keystone Cargo",
  "Northwind Freight", "Copper Ridge Mining", "Delta Warehousing", "Sterling Industrial",
];
const CLIENT_STAGES = ["Onboarding", "Testing", "Intervention"];

const MOCK_ROWS: Record<DashTab, DashRow[]> = {
  clients: CLIENT_NAMES.map((name, i) => ({
    id: `c${i}`,
    primary: name,
    secondary: CLIENT_STAGES[i % 3],
    badge: { label: "Client", tone: "green" },
    date: `Mar ${((i * 2) % 27) + 1}, 2026`,
    href: "#",
  })),
  leads: [
    { id: "l1", primary: "Pinnacle Movers", secondary: "Website", badge: { label: "Working", tone: "blue" }, date: "Jun 14, 2026", href: "#" },
    { id: "l2", primary: "Redwood Distribution", secondary: "Goals questionnaire", badge: { label: "Working", tone: "blue" }, date: "Jun 9, 2026", href: "#" },
    { id: "l3", primary: "Atlas Logistics", secondary: "Added by hand", badge: { label: "Working", tone: "blue" }, date: "Jun 17, 2026", href: "#" },
  ],
  onhold: [
    { id: "h1", primary: "Cedar Transport", secondary: "Budget frozen until the new fiscal year", badge: { label: "Oct 1, 2026", tone: "muted" }, date: "May 21, 2026", href: "#" },
  ],
  archive: [
    { id: "a1", primary: "Summit Haulage", secondary: "Too small", badge: { label: "Archived", tone: "muted" }, date: "Jun 12, 2026", href: "#" },
    { id: "a2", primary: "Ironside Mfg", secondary: "Referred to the network", badge: { label: "Archived", tone: "muted" }, date: "Jun 11, 2026", href: "#" },
  ],
};

const MOCK_COUNTS = { clients: CLIENT_NAMES.length, leads: 3, onhold: 1, archive: 2 };

export function AdminDashboardPreviewPage() {
  const [activeTab, setActiveTab] = useState<DashTab>("clients");
  return (
    <div style={{ minHeight: "100vh", background: "#0B1320", padding: "24px" }}>
      <div style={{ maxWidth: 1040, margin: "0 auto" }}>
        <AdminDashboardView
          counts={MOCK_COUNTS}
          activeTab={activeTab}
          onTabChange={setActiveTab}
          rows={MOCK_ROWS[activeTab]}
          loading={false}
        />
      </div>
    </div>
  );
}
